// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header oficial en estado autenticado para ejemplos funcionales. */
.bw-demo-header.header {
  position: relative;
  top: auto;
  border-bottom: 1px solid rgba(19, 35, 29, 0.08);
  background: #f7f5f1;
  box-shadow: none;
}

.bw-demo-header .header-inner {
  width: min(100%, var(--base-container));
  max-width: var(--base-container);
  margin: 0 auto;
  grid-template-columns: 220px minmax(0, 1fr) 388px;
  column-gap: 44px;
  padding: 14px 16px 14px 40px;
}

.bw-signed-actions {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  white-space: nowrap;
}

.bw-signed-actions .lang-switch {
  gap: 7px;
  font-size: 14px;
}

.bw-signed-actions .lang-switch img {
  width: 16px;
  height: 16px;
}

.bw-header-icon {
  position: relative;
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #13231d;
  cursor: pointer;
  transition: color 0.18s ease, background 0.18s ease;
}

.bw-header-icon:hover,
.bw-header-icon.is-active {
  color: #5e806c;
  background: rgba(130, 177, 148, 0.12);
}

.bw-header-icon svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.bw-header-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  padding: 0 4px;
  border: 2px solid #f7f5f1;
  border-radius: 999px;
  background: #82b194;
  color: #fff;
  font-size: 7px;
  font-weight: 800;
}

.bw-header-user {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-left: 2px;
  color: #13231d;
  font-size: 14px;
  font-weight: 700;
}

.bw-header-user img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}

.bw-header-user svg {
  width: 13px;
  height: 13px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
}

.bw-header-menu {
  position: absolute;
  top: calc(100% + 14px);
  right: 0;
  z-index: 60;
  width: 330px;
  padding: 10px;
  border: 1px solid rgba(19, 35, 29, 0.1);
  border-radius: 18px;
  background: #f7f5f1;
  box-shadow: 0 20px 50px rgba(19, 35, 29, 0.14);
}

.bw-header-menu[hidden] {
  display: none;
}

.bw-header-menu-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 8px 10px;
}

.bw-header-menu-title strong {
  font-size: 13px;
}

.bw-header-menu-title span {
  color: #65756e;
  font-size: 9px;
}

.bw-menu-item {
  width: 100%;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) 7px;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 0;
  border-radius: 13px;
  background: transparent;
  color: #13231d;
  text-align: left;
  cursor: pointer;
}

.bw-menu-item:hover {
  background: rgba(130, 177, 148, 0.1);
}

.bw-menu-avatar,
.bw-menu-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
}

.bw-menu-avatar {
  object-fit: cover;
}

.bw-menu-icon {
  display: grid;
  place-items: center;
  background: #e5ede7;
  color: #4b705c;
  font-size: 10px;
  font-weight: 900;
}

.bw-menu-copy {
  min-width: 0;
}

.bw-menu-copy strong,
.bw-menu-copy span,
.bw-menu-copy em {
  display: block;
}

.bw-menu-copy strong {
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bw-menu-copy span {
  margin-top: 3px;
  color: #65756e;
  font-size: 8px;
  line-height: 1.4;
  white-space: normal;
  word-wrap: break-word;
}

.bw-menu-copy em {
  margin-top: 4px;
  color: #876822;
  font-size: 8px;
  font-style: normal;
  font-weight: 800;
}

.bw-unread {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #dda83e;
}

@media (max-width: 1080px) {
  .bw-demo-header .header-inner {
    grid-template-columns: 170px minmax(0, 1fr) auto;
    column-gap: 20px;
    padding-inline: 20px;
  }

  .bw-demo-header .nav {
    gap: 15px;
  }

  .bw-demo-header .nav a {
    font-size: 12px;
  }

  .bw-header-user strong {
    display: none;
  }
}

@media (max-width: 820px) {
  .bw-demo-header .header-inner {
    grid-template-columns: 1fr auto;
  }

  .bw-demo-header .nav {
    display: none;
  }
}

@media (max-width: 520px) {
  .bw-demo-header .header-inner {
    padding-inline: 14px;
  }

  .bw-demo-header .logo img {
    height: 31px;
  }

  .bw-header-user,
  .bw-signed-actions .lang-switch {
    display: none;
  }

  .bw-header-menu {
    position: fixed;
    top: 70px;
    right: 10px;
    width: min(330px, calc(100vw - 20px));
  }
}

@media(max-width:760px){
  .bw-demo-header .header-inner{padding-top:10px;padding-bottom:10px}
}

`, "",{"version":3,"sources":["webpack://./src/assets/styles/official-signed-header.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,SAAS;EACT,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,cAAc;EACd,iDAAiD;EACjD,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mDAAmD;AACrD;;AAEA;;EAEE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;IAChD,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,qCAAqC;EACvC;AACF;;AAEA;EACE,8BAA8B,gBAAgB,CAAC,mBAAmB;AACpE","sourcesContent":["/* Header oficial en estado autenticado para ejemplos funcionales. */\n.bw-demo-header.header {\n  position: relative;\n  top: auto;\n  border-bottom: 1px solid rgba(19, 35, 29, 0.08);\n  background: #f7f5f1;\n  box-shadow: none;\n}\n\n.bw-demo-header .header-inner {\n  width: min(100%, var(--base-container));\n  max-width: var(--base-container);\n  margin: 0 auto;\n  grid-template-columns: 220px minmax(0, 1fr) 388px;\n  column-gap: 44px;\n  padding: 14px 16px 14px 40px;\n}\n\n.bw-signed-actions {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 14px;\n  white-space: nowrap;\n}\n\n.bw-signed-actions .lang-switch {\n  gap: 7px;\n  font-size: 14px;\n}\n\n.bw-signed-actions .lang-switch img {\n  width: 16px;\n  height: 16px;\n}\n\n.bw-header-icon {\n  position: relative;\n  width: 34px;\n  height: 34px;\n  display: grid;\n  place-items: center;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: #13231d;\n  cursor: pointer;\n  transition: color 0.18s ease, background 0.18s ease;\n}\n\n.bw-header-icon:hover,\n.bw-header-icon.is-active {\n  color: #5e806c;\n  background: rgba(130, 177, 148, 0.12);\n}\n\n.bw-header-icon svg {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.bw-header-badge {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  min-width: 16px;\n  height: 16px;\n  display: grid;\n  place-items: center;\n  padding: 0 4px;\n  border: 2px solid #f7f5f1;\n  border-radius: 999px;\n  background: #82b194;\n  color: #fff;\n  font-size: 7px;\n  font-weight: 800;\n}\n\n.bw-header-user {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin-left: 2px;\n  color: #13231d;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.bw-header-user img {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.bw-header-user svg {\n  width: 13px;\n  height: 13px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n}\n\n.bw-header-menu {\n  position: absolute;\n  top: calc(100% + 14px);\n  right: 0;\n  z-index: 60;\n  width: 330px;\n  padding: 10px;\n  border: 1px solid rgba(19, 35, 29, 0.1);\n  border-radius: 18px;\n  background: #f7f5f1;\n  box-shadow: 0 20px 50px rgba(19, 35, 29, 0.14);\n}\n\n.bw-header-menu[hidden] {\n  display: none;\n}\n\n.bw-header-menu-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 7px 8px 10px;\n}\n\n.bw-header-menu-title strong {\n  font-size: 13px;\n}\n\n.bw-header-menu-title span {\n  color: #65756e;\n  font-size: 9px;\n}\n\n.bw-menu-item {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 38px minmax(0, 1fr) 7px;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  border: 0;\n  border-radius: 13px;\n  background: transparent;\n  color: #13231d;\n  text-align: left;\n  cursor: pointer;\n}\n\n.bw-menu-item:hover {\n  background: rgba(130, 177, 148, 0.1);\n}\n\n.bw-menu-avatar,\n.bw-menu-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n}\n\n.bw-menu-avatar {\n  object-fit: cover;\n}\n\n.bw-menu-icon {\n  display: grid;\n  place-items: center;\n  background: #e5ede7;\n  color: #4b705c;\n  font-size: 10px;\n  font-weight: 900;\n}\n\n.bw-menu-copy {\n  min-width: 0;\n}\n\n.bw-menu-copy strong,\n.bw-menu-copy span,\n.bw-menu-copy em {\n  display: block;\n}\n\n.bw-menu-copy strong {\n  overflow: hidden;\n  font-size: 10px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.bw-menu-copy span {\n  margin-top: 3px;\n  color: #65756e;\n  font-size: 8px;\n  line-height: 1.4;\n  white-space: normal;\n  word-wrap: break-word;\n}\n\n.bw-menu-copy em {\n  margin-top: 4px;\n  color: #876822;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 800;\n}\n\n.bw-unread {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #dda83e;\n}\n\n@media (max-width: 1080px) {\n  .bw-demo-header .header-inner {\n    grid-template-columns: 170px minmax(0, 1fr) auto;\n    column-gap: 20px;\n    padding-inline: 20px;\n  }\n\n  .bw-demo-header .nav {\n    gap: 15px;\n  }\n\n  .bw-demo-header .nav a {\n    font-size: 12px;\n  }\n\n  .bw-header-user strong {\n    display: none;\n  }\n}\n\n@media (max-width: 820px) {\n  .bw-demo-header .header-inner {\n    grid-template-columns: 1fr auto;\n  }\n\n  .bw-demo-header .nav {\n    display: none;\n  }\n}\n\n@media (max-width: 520px) {\n  .bw-demo-header .header-inner {\n    padding-inline: 14px;\n  }\n\n  .bw-demo-header .logo img {\n    height: 31px;\n  }\n\n  .bw-header-user,\n  .bw-signed-actions .lang-switch {\n    display: none;\n  }\n\n  .bw-header-menu {\n    position: fixed;\n    top: 70px;\n    right: 10px;\n    width: min(330px, calc(100vw - 20px));\n  }\n}\n\n@media(max-width:760px){\n  .bw-demo-header .header-inner{padding-top:10px;padding-bottom:10px}\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
